module.exports = __webpack_public_path__ + "static/media/Session-Save.7c2daa71.svg";